// extracted by mini-css-extract-plugin
export var button = "_87284";
export var label = "_2df12";
export var spinner = "_28134";
export var submitting = "_1d14d";